import React from "react";
import parse from "html-react-parser";

const HTMLRenderer = ({ html = "" }) => {
    return <div>{parse(html)}</div>;
};

export default HTMLRenderer;
